import Button from "../../components/Button/Button";
import EmptyView from "../../components/EmptyView";
import List from "../../components/List/List";
import ListItem from "../../components/List/ListItem";
import LightPageLayout from "../../components/Page/LightPageLayout";
import PageHeader from "../../components/Page/PageHeader";
import { useOutgoingRequest } from "../../data/tanstack-query";
import { getEmails } from "../../endpoints/outgoing-requests";
import { EmailStatusInfo } from "../../enums/EmailStatus";
import { mailRoute, newMailRoute } from "./navigation";

export default function MailingPage() {
    const emails = useOutgoingRequest(getEmails());
    return (
        <LightPageLayout>
            <PageHeader
                title="Mailing"
                action={
                    <Button
                        label="Nouveau"
                        action={newMailRoute.getLocation()}
                        feeling="minor"
                        role="minor"
                    />
                }
            />
            <List
                items={emails}
                keyExtractor={(email) => email.id}
                children={(email) => (
                    <ListItem
                        icon="email"
                        label={email.subject}
                        help={`${email.recipientName} · ${email.recipientEmail} · ${EmailStatusInfo[email.status].label} · ${formatDate(email.statusAt)}`}
                        action={mailRoute.getLocation({ pathParams: { email: email.id } })}
                    />
                )}
                empty={<EmptyView message="Aucun email envoyé" />}
            />
        </LightPageLayout>
    );
}

function formatDate(value: string) {
    return new Date(value).toLocaleString("fr-FR");
}
